<template>
	<div class="mp-wrap">
		<div class="mp-header">
			<div class="mp-top">
				<button class="icon-btn" @click="$emit('back')">
					<img src="@/assets/mobile/icon/back.png" alt="Back">
				</button>
				<button class="icon-btn" @click="$emit('close')">
					<img src="@/assets/mobile/icon/close.png" alt="Close">
				</button>
			</div>
			<div class="mp-breadcrumb">
				<span class="mp-crumb" @click="$emit('back')">Collection</span>
				<span class="mp-crumb-active">{{ sectionLabel }}</span>
			</div>
		</div>

		<div class="mp-content" ref="scrollContainer">
			<div class="mp-grid">
				<div v-for="(item, idx) in visibleItems" :key="idx" class="mp-card" @click="openItem(item)">
					<img :src="item.image" :alt="item.label">
					<div class="mp-title">{{ item.label }}</div>
				</div>
			</div>
			<div ref="sentinel" class="mp-sentinel"></div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'MenuProduct',
	props: {
		tab: { type: String, default: '' },
		section: { type: String, default: '' },
		items: { type: Array, default: () => [] }
	},
	data() {
		return {
			observer: null,
			visibleItems: [],
			page: 0,
			pageSize: 4
		}
	},
	computed: {
		sectionLabel() {
			const map = { table: 'TABLE', seating: 'SEATING', accessories: 'ACCESSORIES' }
			return map[this.section] || 'TABLE'
		}
	},
	methods: {
		loadMore() {
			if (this.page * this.pageSize >= this.items.length) return
			const start = this.page * this.pageSize
			const end = start + this.pageSize
			this.visibleItems = this.visibleItems.concat(this.items.slice(start, end))
			this.page += 1
		},
		resetAndLoad() {
			this.page = 0
			this.visibleItems = []
			this.loadMore()
		},
		onIntersect(entries) {
			const entry = entries[0]
			if (entry && entry.isIntersecting) this.loadMore()
		},
		openItem(item) {
			this.$router.push({ path: '/m/product', query: { CategoryID: item.CategoryID } })
			this.$emit('close')
		}
	},
	mounted() {
		this.resetAndLoad()
		const root = this.$el.closest('.m-sheet') || null
		this.observer = new IntersectionObserver(this.onIntersect, { root, threshold: 0.1 })
		if (this.$refs.sentinel) this.observer.observe(this.$refs.sentinel)
	},
	beforeDestroy() {
		if (this.observer) { this.observer.disconnect(); this.observer = null }
	},
	watch: {
		items: { handler() { this.resetAndLoad() }, immediate: true },
		section() { this.resetAndLoad() }
	}
}
</script>

<style scoped>
.mp-wrap {
	display: flex;
	flex-direction: column;
	height: 100%;
	padding: 0 !important;
	padding-top: 32px !important;
	overflow: hidden;
}

/* ★ 核心修复 3：产品面板顶部也加上 70% 毛玻璃，保持统一 */
.mp-header {
	flex-shrink: 0;
	position: sticky;
	top: 0;
	z-index: 10;
	/* background: rgba(255, 255, 255, 0.70);
	backdrop-filter: blur(20px);
	-webkit-backdrop-filter: blur(20px); */
}

.mp-top {
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin-bottom: 16px;
	padding: 0 23px;
}
.mp-breadcrumb {
	display: flex;
	align-items: center;
	gap: 65px;
	padding: 16px 23px 25px 23px;
	font-family: 'Apercu-Medium', sans-serif !important;
}

.mp-crumb { font-size: 13px; font-weight: 500; color: #999; cursor: pointer; }
.mp-crumb-active { font-size: 14px; font-weight: 500; color: #000; }

/* ★ 核心修复 4：绝对防错滚动 + 隐藏滚动条 */
.mp-content {
	flex: 1;
	overflow-y: auto;
	-webkit-overflow-scrolling: touch;
	padding-bottom: 40px;
}
.mp-content::-webkit-scrollbar { display: none; }

.mp-grid {
	display: grid;
	grid-template-columns: 1fr 1fr;
	gap: 4px;
	padding: 0 15px;
}

.mp-card { display: flex; flex-direction: column; gap: 8px; padding-bottom: 20px; }
.mp-card img { object-fit: cover; width: 100%; height: 245px; }
.mp-title { font-size: 10px; color: #000; font-family: 'Apercu-Medium', sans-serif !important; }

.mp-sentinel { width: 100%; height: 1px; }

.icon-btn {
	background: none; border: none; padding: 0;
	height: 15px; width: 12px;
	display: flex; align-items: center; justify-content: center;
	font-size: 18px; color: #000; cursor: pointer;
}
</style>